import { Link } from "@/i18n/navigation";
import { Icon } from "@ama-pt/agora-design-system";
import React from "react";

interface LinkButtonProps {
  hasIcon?: boolean;
  className?: string;
  leadingIcon?: string;
  trailingIcon?: string;
  link: string;
  label: string;
  target?: string;
}

export default function BupiLinkButton({
  hasIcon,
  className,
  leadingIcon,
  trailingIcon,
  link,
  label,
  target,
}: LinkButtonProps) {
  return (
    <Link
      className={`${className ?? ""} agora-btn agora-btn-solid-primary ${
        hasIcon ? "agora-btn-with-icon" : ""
      } p-16 bupi-hover hover:text-white flex items-center justify-center`}
      title={"Navegar para página " + label}
      href={link as any}
      target={target}
    >
      {trailingIcon && (
        <span className="icon-wrapper leading" aria-hidden="true">
          <Icon className="leading-icon-default" name={trailingIcon} />
        </span>
      )}
      <span className="children-wrapper">
        <span className="text-m-regular">{label}</span>
      </span>
      {leadingIcon && (
        <span className="icon-wrapper trailing" aria-hidden="true">
          <Icon className="trailing-icon-default" name={leadingIcon} />
        </span>
      )}
    </Link>
  );
}
